<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <vue-title :title="pageTitle + ' | JUDO POS'"></vue-title>
    <v-layout row>
      <v-flex xs12 v-if="isBreadcrumbs">
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap transition="slide-x-transition">
        <v-flex xs6 mt-1>
          <v-card>
            <v-layout row wrap>
              <!-- Barcode input -->
              <v-flex xs7 ml-4>
                <v-text-field
                  name="scanBarcode"
                  label="Scan barcode....."
                  v-model="scanBarcode"
                  type="text"
                  v-on:keyup.enter="trigger(scanBarcode)"
                  autofocus
                  prepend-icon="filter_center_focus"
                ></v-text-field>
              </v-flex>
              <!-- Barcode input -->

              <v-flex xs3 mt-1>
                <v-btn color="primary" outline dark @click="isShowStock=!isShowStock; ">
                  <v-icon left>remove_red_eye</v-icon>
                  <span v-if="!isShowStock">Show Stock</span>
                  <span v-else>Hide Stock</span>
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <!-- Barcode input -->
              <v-flex xs7 ml-4>
                <v-autocomplete
                  name="enteredProductCode"
                  label="Product Code/Name"
                  v-model="enteredProductCode"
                  :items="productListByCodeOrName"
                  :filter="productSelectFilter"
                  v-on:keyup.enter="getProductByCode(enteredProductCode)"
                  autofocus
                  prepend-icon="assignment_returned"
                  item-text="code"
                  item-value="code"
                  :search-input.sync="codeSearch"
                  menu-props="auto"
                >
                  <template v-slot:item="data">
                    <v-list-tile-content
                      @click="getProductByCode(data.item.code)"
                      v-html="data.item.code + '/' + data.item.name"
                    ></v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs2 ml-2 mt-1>
                <v-switch v-model="isFOC" inset :label="isFOC == true ? 'FOC' : 'Sale'"></v-switch>
              </v-flex>

              <v-flex xs2 ml-2 mt-1>
                <v-switch
                  v-model="isItemDiscount"
                  inset
                  :label="isItemDiscount == true ? 'discount' : 'discount'"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-divider></v-divider>
            <!-- Sale Items cart -->
            <v-flex xs16 ma-3 pa-2>
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <div class="title">Sale Items</div>
                  </div>
                </v-card-title>
                <v-card-text class="cart">
                  <v-layout row>
                    <v-flex xs2>Code</v-flex>
                    <v-flex xs2 class="text-xs-center">Stock Name</v-flex>
                    <v-flex xs1 class="text-xs-center">Unit</v-flex>
                    <v-flex xs2 class="text-xs-center">Qty</v-flex>
                    <v-flex xs2 class="text-xs-center">Price</v-flex>
                    <v-flex xs1 class="text-xs-center" v-if="isItemDiscount">Discount</v-flex>
                    <v-flex xs2 class="text-xs-center">Amount</v-flex>
                    <v-flex xs1></v-flex>
                  </v-layout>
                  <v-divider></v-divider>

                  <v-flex v-if="getSaleItems.length == 0" text-xs-center ma-3>No items.</v-flex>
                  <v-flex
                    style="max-height:70vh;overflow-y:auto;overflow-x:hidden;"
                    v-for="(item, index) in sale.saleItems"
                    :key="index"
                  >
                    <v-layout row class="white" v-if="item.isFOC !== true">
                      <v-flex xs2 pt-4>{{item.barcode}}</v-flex>
                      <v-flex xs2 pt-4>{{item.productName}}</v-flex>
                      <v-flex xs1 pt-4>{{item.factorUnitName}}</v-flex>
                      <v-flex xs2 class="text-xs-center">
                        <v-text-field
                          v-model="item.qty"
                          min="0"
                          :rules="rules.qtyRules"
                          oninput="this.value = Math.abs(this.value)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 pt-4 class="text-xs-center">
                        {{item.unitPrice | decFormat(6)}}
                        <span
                          v-if="isShowCurrency"
                        >{{ currency }}</span>
                      </v-flex>
                      <v-flex xs1 class="text-xs-center" v-if="isItemDiscount">
                        <!--{{item.discountPercent}
                        <span>%</span>-->
                        <v-text-field
                          class="small-font"
                          v-model="item.discountPercent"
                          min="0"
                          oninput="this.value = Math.abs(this.value)"
                          :rules="rules.discountPercentRules"
                          suffix="%"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 pt-4 class="text-xs-center" v-if="isItemDiscount">
                        {{item.qty * (item.unitPrice - (item.unitPrice * (item.discountPercent/100))) | decFormat(6)}}
                        <span
                          v-if="isShowCurrency"
                        >{{ currency }}</span>
                      </v-flex>
                      <v-flex xs2 pt-4 class="text-xs-center" v-else>
                        {{item.qty * item.unitPrice | decFormat(6)}}
                        <span
                          v-if="isShowCurrency"
                        >{{ currency }}</span>
                      </v-flex>
                      <v-flex xs1 sm1 pt-2>
                        <v-btn icon @click="removeItem(index)">
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- FOC Items cart -->
            <v-flex xs16 ma-3 pa-2>
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <div class="title">FOC Items</div>
                  </div>
                </v-card-title>
                <v-card-text class="cart">
                  <v-layout row>
                    <v-flex xs2>Code</v-flex>
                    <v-flex xs3 class="text-xs-center">Stock Name</v-flex>
                    <v-flex xs1 class="text-xs-center">Unit</v-flex>
                    <v-flex xs2 class="text-xs-center">Qty</v-flex>
                    <v-flex xs2 class="text-xs-center">Price</v-flex>
                    <v-flex xs1 class="text-xs-center" v-if="isItemDiscount">Discount</v-flex>
                    <v-flex xs2 class="text-xs-center">Amount</v-flex>
                    <v-flex xs1 class="text-xs-center">Remark</v-flex>
                    <v-flex xs1></v-flex>
                  </v-layout>
                  <v-divider></v-divider>

                  <v-flex v-if="getFOCItems.length == 0" text-xs-center ma-3>No items.</v-flex>
                  <v-flex
                    style="max-height:70vh;overflow-y:auto;overflow-x:hidden;"
                    v-for="(item, index) in sale.saleItems"
                    :key="index"
                  >
                    <v-layout row class="white" v-if="item.isFOC === true">
                      <v-flex xs2 pt-4>{{item.barcode}}</v-flex>
                      <v-flex xs3 pt-4>{{item.productName}}</v-flex>
                      <v-flex xs1 pt-4>{{item.factorUnitName}}</v-flex>
                      <v-flex xs2>
                        <v-text-field
                          v-model="item.qty"
                          min="0"
                          :rules="rules.qtyRules"
                          oninput="this.value = Math.abs(this.value)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 pt-4 class="text-xs-center">
                        {{item.unitPrice | decFormat(6)}}
                        <span
                          v-if="isShowCurrency"
                        >{{ currency }}</span>
                      </v-flex>
                      <v-flex xs1 pt-4 class="text-xs-center" v-if="isItemDiscount">
                        {{item.discountPercent}}
                        <span>%</span>
                      </v-flex>
                      <v-flex xs2 pt-4 class="text-xs-center" v-if="isItemDiscount">
                        {{item.qty * (item.unitPrice - (item.unitPrice * (item.discountPercent/100))) | decFormat(6)}}
                        <span
                          v-if="isShowCurrency"
                        >{{ currency }}</span>
                      </v-flex>
                      <v-flex xs2 pt-4 class="text-xs-center" v-else>
                        {{item.qty * item.unitPrice | decFormat(6)}}
                        <span
                          v-if="isShowCurrency"
                        >{{ currency }}</span>
                      </v-flex>
                      <v-flex xs1 class="text-xs-center">
                        <v-text-field
                          v-model="item.remark"
                          name="remark"
                          type="Text"
                          :rules="rules.remarkRules"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs1 pt-2>
                        <v-btn icon @click="removeItem(index)">
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- cart -->
          </v-card>
        </v-flex>
        <v-flex xs6>
          <!-- Stock -->
          <v-slide-y-transition>
            <v-card>
              <v-flex v-show="isShowStock">
                <v-layout row>
                  <v-flex xs8 pa-3 mt-1 class="text-xs-right">
                    <h3>
                      Total Amount: {{netAmount | decFormat(6)}}
                      <span
                        v-if="isShowCurrency"
                      >{{ currency }}</span>
                    </h3>
                  </v-flex>
                  <v-flex xs4 ml-1>
                    <v-btn
                      color="success"
                      large
                      @click="showPaymentMethods()"
                      :disabled="sale.saleItems.length === 0 || !valid"
                    >Make Payment</v-btn>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-expansion-panel v-model="categoryPanel" mb-3>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div>
                        <strong>Category : {{categoryName}}</strong>
                      </div>
                    </template>
                    <v-layout row wrap pa-2>
                      <v-flex xs4 v-for="(category, index) in categoryList" :key="index">
                        <v-btn
                          block
                          color="primary"
                          @click="onSearch(category);categoryPanel=null"
                        >{{category.name}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-flex mt-3 style="max-height:100vh;overflow-y:auto;overflow-x:hidden;">
                  <v-data-iterator
                    :items="productList"
                    :total-items="totalRows"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                    :loading="showListLoading"
                    content-tag="v-layout"
                    row
                    wrap
                  >
                    <v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3>
                      <v-hover>
                        <v-card
                          slot-scope="{ hover }"
                          :class="`elevation-${hover ? 4 : 0}`"
                          class="mx-auto"
                          :title="props.item.name"
                          @click="showProductUnitDialog(props.item)"
                        >
                          <v-img
                            v-if="props.item.imageUrl"
                            :aspect-ratio="16/9"
                            :src="props.item.imageUrl"
                            height="150px"
                            width="150px"
                          ></v-img>
                          <v-card-title>
                            <div class="grey--text">{{props.item.code}}</div>
                            <div class="stock-name">{{props.item.name}}</div>
                          </v-card-title>
                        </v-card>
                      </v-hover>
                    </v-flex>
                  </v-data-iterator>
                </v-flex>
              </v-flex>
            </v-card>
          </v-slide-y-transition>

          <!-- Stock -->
          <v-slide-y-reverse-transition>
            <v-flex v-show="!isShowStock">
              <v-layout row>
                <!-- Counter Detail -->
                <v-flex xs6 pb-2>
                  <v-flex xs12>
                    <strong>Shop Name:</strong>
                    {{sale.shopName}}
                  </v-flex>
                  <v-flex xs12>
                    <strong>Counter Name:</strong>
                    {{sale.counterName}}
                  </v-flex>
                </v-flex>
                <!-- Counter Detail -->

                <!-- Retrieve / Park Sale -->
                <v-flex xs6 mt-2>
                  <v-btn @click="showParkSales = !showParkSales">
                    <i class="material-icons">reply</i>Retrieve Sale
                  </v-btn>
                  <v-btn @click="showNote = !showNote" :disabled="sale.saleItems.length === 0">
                    <i class="material-icons">settings_backup_restore</i>Park Sale
                  </v-btn>
                </v-flex>
                <!-- Retrieve / Park Sale -->
              </v-layout>
              <!--  -->
              <!-- receipt Section -->
              <v-divider></v-divider>
              <v-layout row>
                <v-flex xs8>Total Amount:</v-flex>
                <v-flex xs4 class="text-xs-right">
                  {{sale.totalAmount | decFormat(6)}}
                  <span
                    v-if="isShowCurrency"
                  >{{ currency }}</span>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs8>Tax({{sale.taxType}})({{sale.taxPercentage}}%):</v-flex>
                <v-flex xs4 class="text-xs-right">
                  {{sale.taxAmount | decFormat(6)}}
                  <span
                    v-if="isShowCurrency"
                  >{{ currency }}</span>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout row>
                <v-flex xs8>
                  <h3>Net Amount:</h3>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <h3>
                    {{netAmount | decFormat(6)}}
                    <span
                      v-if="isShowCurrency"
                    >{{ currency }}</span>
                  </h3>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout row>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    color="success"
                    large
                    @click="showPaymentMethods()"
                    :disabled="sale.saleItems.length === 0"
                  >Make Payment</v-btn>
                </v-flex>
              </v-layout>
              <!-- receipt section -->
            </v-flex>
          </v-slide-y-reverse-transition>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Invoice print hidden area -->
    <!-- <invoice id="invoicePrint" :sale-data="sale"></invoice> -->
    <div id="invoicePrint" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px">{{sale.shopName}}</p>
      </div>
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px">{{sale.address}}</p>
      </div>
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px">Tel: {{sale.phoneNo}}</p>
      </div>
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px">Invoice #: {{sale.saleNo}}</p>
      </div>
      <div style="text-align:center">
        <p style="font-size:11px;margin:0px" id="date"></p>
      </div>
      <div style="float:left;padding-left:11px">
        <p style="font-size:11px;margin:0px" id="counter">Counter: {{sale.counterName}}</p>
      </div>
      <div style="float:left;padding-left:11px">
        <p style="font-size:11px;margin:0px" id="counter">Currency: {{sale.currencyCode}}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p style="font-size:11px;margin:0px" id="casher">Casher: {{sale.username}}</p>
      </div>
      <div style="clear:both"></div>
      <div style="height:10px"></div>
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left"></th>
              <th style="text-align:center">Unit</th>
              <th style="text-align:center">Qty</th>
              <th style="text-align:right">Price</th>
              <th style="text-align:right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getSaleItems" :key="index">
              <td style="text-align:left">{{item.productName}}</td>
              <td style="text-align:center">
                {{item.factorUnitName}}
                <span v-if="sale.isItemDiscount">({{item.discountPercent}}%)</span>
              </td>
              <td style="text-align:center">{{item.qty | decFormat(6) }}</td>
              <td style="text-align:right">{{item.unitPrice | decFormat(6)}}</td>
              <td
                v-if="sale.isItemDiscount"
                style="text-align:right"
              >{{item.qty * (item.unitPrice - (item.unitPrice * (item.discountPercent/100))) | decFormat(6)}}</td>
              <td v-else style="text-align:right">{{item.qty * item.unitPrice | decFormat(6) }}</td>
            </tr>
          </tbody>
        </table>
        <div style="height:10px"></div>
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Total Amount</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >{{sale.totalAmount | decFormat(6)}}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Tax ({{sale.taxType}})</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >{{sale.taxAmount | decFormat(6)}}</td>
          </tr>
          <tr>
            <td colspan="3" style="text-align:right;font-weight:bold;font-size:11px">Expense Amount</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >{{this.sale.expenseAmount | decFormat(6)}}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Discount Amount</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
              v-if="this.sale.discountAmount > 0"
            >{{this.sale.discountAmount | decFormat(6)}}</td>
            <td style="text-align:right;font-weight:bold;font-size:11px" v-else>0</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Net Amount</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >{{netAmount | decFormat(6)}}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Received</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >{{sale.receivedAmount | decFormat(6)}}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style="text-align:right;font-weight:bold;font-size:11px">Pay Change</td>
            <td
              style="text-align:right;font-weight:bold;font-size:11px"
            >{{sale.payChange | decFormat(6)}}</td>
          </tr>
        </table>
      </div>
      <!-- FOC Items -->
      <div style="clear:both"></div>
      <div style="height:10px"></div>
      <div style="padding-left:5px;padding-right:5px" v-if="getFOCItems.length > 0">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">FOC Items</th>
              <th style="text-align:center">Unit</th>
              <th style="text-align:center">Qty</th>
              <th style="text-align:right">Price</th>
              <th style="text-align:right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getFOCItems" :key="index">
              <td style="text-align:left">{{item.productName}}</td>
              <td style="text-align:center">
                {{item.factorUnitName}}
                <span v-if="sale.isItemDiscount">({{item.discountPercent}}%)</span>
              </td>
              <td style="text-align:center">{{item.qty | decFormat(6) }}</td>
              <td style="text-align:right">{{item.unitPrice | decFormat(6)}}</td>
              <td
                style="text-align:right"
              >{{item.qty * (item.unitPrice - (item.unitPrice * (item.discountPercent/100))) | decFormat(6)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="text-align: right;" v-if="user.signature">
        <div style="display: inline-block;">
          <img style="height: 100px;width: 100px;display:block;" :src="user.signature" />
          <span style="display:block;">------------------</span>
          <span style="display:block;text-align:center;font-size:11px;">Signature</span>
        </div>
      </div>
      <div style="text-align:center">
        <p style="font-size:11px;">Money Pay Back Guarantee</p>
        <p style="font-size:11px;">Thank You Very Much</p>
      </div>
    </div>
    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Park sales dialog-->
    <v-dialog v-model="showParkSales" persistent max-width="500">
      <v-card>
        <v-card-title>
          <h3>Park Sales</h3>
        </v-card-title>
        <v-card-text>
          <v-layout row v-for="(item, index) in parkItems" :key="index">
            <v-flex xs12 sm3 class="grey--text">Note: {{item.note}}</v-flex>
            <v-flex xs12 sm3>{{item.saleItems[0].barcode}}</v-flex>
            <v-flex xs12 sm3>{{item.saleItems[0].productName}}</v-flex>
            <v-flex xs12 sm3>{{item.saleItems[0].factorUnitName}}</v-flex>
            <v-flex xs12 sm3>
              <v-btn color="primary" @click="retrieveSale(index)">
                <v-icon>reply</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row v-show="parkItems.length === 0">
            <v-flex>There is no park sale.</v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="showParkSales = !showParkSales">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Show note dialog-->
    <v-dialog v-model="showNote" persistent max-width="290">
      <v-form ref="noteDialog" @submit.prevent="parkSale">
        <v-card>
          <v-card-text>
            <v-text-field
              label="Note"
              required
              v-model="sale.note"
              :rules="[v => !!v || 'Note is required']"
            ></v-text-field>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" flat @click.native="closeModal">
                Cancel
                <v-icon right>clear</v-icon>
              </v-btn>
              <v-btn color="blue darken-1" flat type="submit">
                Save
                <v-icon right>save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <!--Payment dialog-->
    <v-dialog v-model="showPaymentMethodDialog" max-width="800" @keydown.enter="confirmPayment()">
      <v-form ref="paymentModalForm" lazy-validation @submit.prevent="confirmPayment">
        <v-card>
          <v-card-text max-height="auto">
            <!--Choose Created Date -->
            <v-layout row wrap v-if="sale.backDateDataEntry == 'ACTIVE'">
              <v-flex xs5>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="createdDate"
                    label="Created Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs5>
                <v-menu
                  ref="menu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="createdTime"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="createdTime"
                      label="Created Time"
                      prepend-icon="access_time"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu2"
                    v-model="createdTime"
                    full-width
                    @click:minute="$refs.menu.save(createdTime)"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <!--Choose Created Date -->
            <v-layout row>
              <v-flex xs5>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>Payment Method</h2>
                  <v-select :items="payTypes" label="payType" v-model="payType" 
                  @change="calculateAmount" solo></v-select>
                </v-flex>
              </v-flex>
              <v-flex xs3>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>Tax On</h2>
                  <v-checkbox v-model="isTaxOn" @change="calculateAmount"></v-checkbox>
                </v-flex>
              </v-flex>
              <v-flex xs4>
                <v-flex ml-3 mr-3 mt-2 v-if="payType == 'CREDIT'">
                  <h2>Advanced Amount</h2>
                  <v-checkbox v-model="isAdvancedAmount" @change="calculateAmount"></v-checkbox>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row v-if="payType == 'CREDIT'">
              <v-flex sm6 pl-3>
                <v-text-field
                  placeholder="Choose Customer"
                  v-model="sale.customerName"
                  @click.stop="showCustomers()"
                  :rules="rules.customerIdRules"
                >
                  <template v-slot:prepend>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @mouseup.stop
                          @click.prevent.stop="addNewCustomer"
                        >
                          person_add
                        </v-icon>
                      </template>
                      <span>New Customer</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex sm6 mt-4 v-if="sale.customerName">
                <v-layout row>
                  <v-flex class="ml-3" xs6>
                    <h3 style="font-weight:bold;">Total Advanced Amount</h3>
                  </v-flex>
                  <v-flex xs2 style="font-weight:bold;">
                    <h3>:</h3>
                  </v-flex>
                  <v-flex xs4 style="font-weight:bold;">
                    <h3>{{ totaladvancedAmount | decFormat(6) }}</h3>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex xs12>
                <v-flex ma-3>
                  <h2>
                    Total Amount :
                    <span style="color:green">
                      {{sale.totalAmount | decFormat(6)}}
                      <span
                        v-if="isShowCurrency"
                      >{{ currency }}</span>
                    </span>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12 v-if="isTaxOn">
                <v-flex ma-3>
                  <h2>
                    Tax({{sale.taxType}}):
                    <span style="color:red">
                      {{ sale.taxAmount | decFormat(6)}}
                      <span
                        v-if="isShowCurrency"
                      >{{ currency }}</span>
                    </span>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12>
                <v-flex ml-3 mr-3 mt-2>
                  <v-layout row align-center>
                    <v-flex shrink>
                      <h2>
                        <strong class="d-flex flex-shirnk">
                          Discount Amount
                        </strong>
                      </h2>
                    </v-flex>

                    <v-flex grow>
                      <v-switch 
                        class="mt-0 pt-0 ml-3"
                        v-model="isDiscountPercentage"
                        :label="`Percentage ${ isDiscountPercentage ? 'ON' : 'OFF' }`"
                        hide-details
                        @change="changeDiscountSwitch()"
                      ></v-switch>
                    </v-flex>
                  </v-layout>

                  <v-text-field
                    v-if="!isDiscountPercentage"
                    v-model="sale.discountAmount"
                    label="Amount"
                    min="0"
                    outline
                    :suffix="currency"
                    :rules="rules.discountAmountRules"
                  >
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </v-text-field>

                  <v-text-field
                    v-else
                    v-model="sale.discountPercentage"
                    min="0"
                    outline
                    :suffix="'%'"
                    :rules="rules.discountPercentRules"
                  >
                  </v-text-field>




                    <!--<v-text-field
                      v-model="sale.discountAmount"
                      label="Amount"
                      min="0"
                      outline
                      :prefix="currency"
                      :rules="rules.discountAmountRules"
                      v-if="showPaymentMethodDialog && !confirmBox"
                      autofocus
                      @focus="$event.target.select()"
                    >
                      <span v-if="isShowCurrency">{{ currency }}</span>
                    </v-text-field>-->
                </v-flex>
              </v-flex>
              <v-flex xs12>
                <v-flex ml-3 mr-3 mt-2>
                  <v-layout row align-center>
                    <v-flex shrink>
                      <h2>
                        <strong class="d-flex flex-shirnk">
                          Promotion
                        </strong>
                      </h2>
                    </v-flex>

                    <v-flex grow>
                      <v-switch 
                        class="mt-0 pt-0 ml-3"
                        v-model="isPromotionPercentage"
                        :label="`Percentage ${ isPromotionPercentage ? 'ON' : 'OFF' }`"
                        hide-details
                        @change="changePromotionSwitch()"
                      ></v-switch>
                    </v-flex>
                  </v-layout>

                  <v-text-field
                    v-if="!isPromotionPercentage"
                    v-model="sale.promotionAmount"
                    label="Amount"
                    min="0"
                    outline
                    :suffix="currency"
                    :rules="rules.promotionAmountRules"
                  >
                    <span v-if="isShowCurrency">{{ currency }}</span>
                  </v-text-field>

                  <v-text-field
                    v-else
                    v-model="sale.promotionPercentage"
                    min="0"
                    outline
                    :suffix="'%'"
                    :rules="rules.promotionPercentRules"
                  >
                  </v-text-field>
                </v-flex>
              </v-flex>
              <v-flex xs12>
                <v-flex ml-3 mr-3 mt-2>
                  <h2>
                    Expense Amount:
                    <v-text-field
                      v-model="sale.expenseAmount"
                      label="Amount"
                      min="0"
                      outline
                      :prefix="currency"
                      :rules="rules.discountAmountRules"
                      v-if="showPaymentMethodDialog && !confirmBox"
                      autofocus
                      @focus="$event.target.select()"
                    >
                      <span v-if="isShowCurrency">{{ currency }}</span>
                    </v-text-field>
                  </h2>
                </v-flex>
              </v-flex>
              <v-flex xs12 ma-3>
                <h1>
                  Net Amount:
                  <span style="color:green">
                    {{ netAmount | decFormat(6)}}
                    <span
                      v-if="isShowCurrency"
                    >{{ currency }}</span>
                  </span>
                </h1>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row>
              <v-flex ma-3>
                <h2>Received :</h2>
                <v-text-field
                  v-model="receivedAmount"
                  min="0"
                  label="Amount"
                  outline
                  prefix="MMK"
                  v-if="showPaymentMethodDialog && !confirmBox"
                  autofocus
                  @focus="$event.target.select()"
                  @input="changeReceiveAmount"
                  :rules="payType == 'CASH' ? rules.receiveAmountRules : [v => v <= netAmount || 'Received Amount must not be greater than net amount.',
                  v => {
                  const pattern = /^\d+(\.\d{1,2})*$/;
                  return pattern.test(v) || 'Invalid deposite amount.';
    }] "
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row v-if="payType == 'CASH'">
              <v-flex ma-3>
                <h1>
                  Pay Change :
                  <span style="color:red">
                    {{ payChangeAmount | decFormat(6)}}
                    <span
                      v-if="isShowCurrency"
                    >{{ currency }}</span>
                  </span>
                </h1>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row>
              <v-flex ma-3>
                <h2>Bin :</h2>
                <v-select
                  :items="binList"
                  item-text="name"
                  item-value="id"
                  v-model="sale.binId"
                  outline
                  :rules="rules.binRules"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row v-if="payType == 'CREDIT'">
              <v-flex ma-3>
                <h2>
                  Remark :
                  <v-text-field v-model="saleRemark" type="Text" :rules="rules.remarkRules"></v-text-field>
                </h2>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex text-xs-center mt-3>
                <v-btn color="success" large outline @click="confirmPayment">Confirm Payment</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="showPaymentMethodDialog = !showPaymentMethodDialog">
              Close
              <v-icon right>clear</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- ProductUnit dialog -->
    <v-dialog v-model="openProductUnitDialog" persistent max-width="700">
      <v-card>
        <v-card-title>
          <h2>Choose Stock</h2>
        </v-card-title>
        <v-card-title>
          <h3>Product Code: {{ productCode }}</h3>
        </v-card-title>
        <v-card-title>
          <h3>Product Name: {{ productName }}</h3>
        </v-card-title>
        <v-layout row wrap pa-2>
          <v-flex v-for="(productUnit, index) in productUnitList" :key="index" xs12 sm6 md4 lg3>
            <v-hover>
              <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 4 : 0}`" class="mx-auto">
                <v-card-title>
                  <p class="grey--text">{{productUnit.barcode}}</p>
                  <p class="grey--text">{{productUnit.product.name}}</p>
                  <p>{{productUnit.sellingPrice | decFormat(6)}} MMK</p>
                  <p>Unit: {{productUnit.factorUnitName}}</p>
                  <p>Available Qty: {{productUnit.qty | decFormat(6) }}</p>
                </v-card-title>
                <v-card-actions>
                  <v-btn
                    :disabled="productUnit.qty == 0"
                    :ref="`bc-${productUnit.barcode}`"
                    outline
                    color="orange"
                    @click="addToCart(productUnit)"
                  >Add To Card</v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex v-if="!productUnitList.length">
            <h5 style="color:red">*There is no productUnit.</h5>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            @click.native="openProductUnitDialog = !openProductUnitDialog"
          >Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Customer list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm2 pl-1>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm2 pl-1>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2 pl-1>
              <v-select
                :items="creditLevelList"
                v-model="customerQueryParams.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm2 pl-1>
              <v-text-field
                name="township"
                label="TownShip"
                type="text"
                v-model="customerQueryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="customerOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="customerList"
                class="elevation-1"
                :loading="showCustomerListLoading"
                :total-items="customerTotalRows"
                :rows-per-page-items="customerRowsPerPageItems"
                :pagination.sync="customerPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td @click="setCustomer(props.item)">
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.creditLevel.name}}</td>
                  <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- confrim dialog -->
    <v-dialog
      v-model="confirmBox"
      max-width="500px"
      @keydown.enter="proceedPayment()"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>Are you sure to make this payment transaction?</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="confirmBox=false">Cancel</v-btn>
          <v-btn
            color="success"
            large
            outline
            :loading="isSaleProcessing"
            :disabled="isSaleProcessing"
            @click="proceedPayment()"
          >Proceed</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- customer add dialog -->
    <customer-add-dialog
      :showDialog="customerAddDialog"
      @close="closeCustomerDialog"
    />
  </v-container>
</template>
<script>
// import invoice from "./invoice";
import { productService } from "../../services/product-service";
import { taxService } from "../../services/tax-service";
import { categoryService } from "../../services/category-service";
import { customerService } from "../../services/customer-service";
import { Tax } from "../../models/model";
import { Sale } from "../../models/model";
import { saleService } from "../../services/sale-service";
import { SaleFormRules } from "../../helpers/validation-rules";
import { creditLevelService } from "../../services/credit-level-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service"
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import customerAddDialog from "../customer/CustomerAddDialog.vue";

export default {
  name: "StockList",
  components: {
    Loading,
    customerAddDialog,
  },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    createdTime: "8:00",
    menu2: false,
    createdDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    rules: new SaleFormRules(),
    valid: true,
    responseError: "",
    isShowStock: false,
    pageTitle: "Sale",
    showListLoading: false,
    showCustomerListLoading: false,
    ignorePagingWatch: true,
    isBreadcrumbs: false,
    breadcrumbs: [
      {
        text: "Sale",
        disabled: true,
      },
    ],
    rowsPerPageItems: [8, 16, 24, 48],
    pagination: {
      page: 1,
      rowsPerPage: 8,
      sortBy: "createdDate",
      totalItems: 0,
    },
    stockList: [],
    categoryName: "",
    decimalFormat: "",
    productList: [],
    categoryList: [],
    counterList: [],
    totalRows: 0,
    customerTotalRows: 0,
    parkItems: [],
    showParkSales: false,
    showNote: false,
    showPaymentMethodDialog: false,
    modalValid: true,
    scanBarcode: "",
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    queryParams: {
      status: "ACTIVE",
      categoryId: "",
      warehouseId: "",
      binIds: [],
      isSale: true,
    },
    customerQueryParams: {
      name: "",
      email: "",
      creditLevelId: "",
      township: "",
      status: "",
    },
    customerRowsPerPageItems: [25, 50, 100],
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    autoCompleteParams: {
      code: "",
    },
    discountPercentage: 0,
    cardNo: "",
    tax: new Tax(),
    tableInfos: [],
    sale: new Sale(),
    netAmount: 0,
    totaladvancedAmount: 0,
    isShowCurrency: true,
    currency: "MMK",
    payTypes: ["CASH", "CREDIT"],
    categoryPanel: null,
    selectedPaymentMethod: 1,
    confirmBox: false,
    productCode: "",
    productName: "",
    productUnitList: [],
    openProductUnitDialog: false,
    payType: "CASH",
    isTaxOn: false,
    isAdvancedAmount: false,
    messageDialogBox: false,
    receivedAmount: 0,
    saleRemark: "",
    productCodeList: [],
    enteredProductCode: "",
    customerList: [],
    isFOC: false,
    isItemDiscount: false,
    saleItems: [],
    focItems: [],
    isFOCItemsExist: false,
    isSaleItemsExist: false,
    isLoading: false,
    fullPage: true,
    showCustomerListDialog: false,
    creditLevelList: [],
    isSaleProcessing: false,
    isDiscountPercentage: true,
    isPromotionPercentage: true,
    customerAddDialog: false,
    productListByCodeOrName: [],
    codeSearch: "",
    binList: []
  }),
  computed: {
    payChangeAmount() {
      return this.receivedAmount - this.netAmount;
    },
    getFOCItems() {
      return this.sale.saleItems.filter((item) => item.isFOC === true);
    },
    getSaleItems() {
      return this.sale.saleItems.filter((item) => item.isFOC !== true);
    },
  },
  watch: {
    pagination: {
      handler() {
        if (!this.ignorePagingWatch) {
          this.getProductList();
        }
      },
      deep: true,
    },
    customerPagination: {
      handler() {
        this.getCustomerList();
      },
      deep: true,
    },
    sale: {
      handler() {
        this.calculateAmount();
      },
      deep: true,
    },
    isItemDiscount: {
      handler() {
        this.toggleDiscount();
      },
      deep: true,
    },
    codeSearch: {
      handler() {
        this.getProductListByCodeOrName();
      }
    },
  },
  created() {
    this.decimalFormat = commonService.formatdecimal();
    this.init();
  },
  mounted() {
    // setTimeout is needed for page reload case.
    setTimeout(() => {
      this.$emit("drawer", false);
    }, 50);
  },
  destroyed() {
    this.$emit("drawer", null);
  },
  methods: {
    getProductByCode(enteredProductCode) {
      let isSale = true;
      productService
        .getProductByCode(enteredProductCode, isSale)
        .then((res) => {
          if (res.data) {
            this.showProductUnitDialog(res.data);
          } else {
            this.responseError = "Invalid Product Code !";
            this.messageDialogBox = true;
          }
          this.enteredProductCode = "";
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getProductListByCodeOrName() {
      if (
        this.codeSearch &&
        this.codeSearch.length > 50 &&
        this.productListByCodeOrName.length > 0
      ) {
        return;
      }
      let searchParams = {
        code: this.codeSearch,
        name: this.codeSearch,
      };
      if (this.codeSearch) {
        productService
          .getProductByNameOrCode(searchParams)
          .then((res) => {
            this.productListByCodeOrName = res.data;
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
          });
      }
    },

    productSelectFilter(item, queryText, itemText) {
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
      );
    },

    getAllCustomer() {
      customerService
        .getAllCustomers()
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    confirmPayment() {
      if (!this.$refs.paymentModalForm.validate()) {
        return;
      }
      this.showPaymentMethodDialog = false;
      this.confirmBox = true;
    },
    proceedPayment() {
      if (!this.isSaleProcessing) {
        this.isSaleProcessing = true;
        this.save();
        this.showPaymentMethodDialog = false;
        this.confirmBox = false;
      }
    },
    cancelPayment() {
      this.showPaymentMethods();
    },
    trigger(barcode) {
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    onSearch(category) {
      if (category) {
        this.queryParams.categoryId = category.id;
        this.categoryName = category.name;
      }
      this.pagination.page = 1;
      this.pagination.rowsPerPage = 8;
      this.$router.replace({ name: "sales", query: this.queryParams });
      this.getProductList();
    },
    customerOnSearch() {
      this.customerQueryParams.page = this.customerPagination.page;
      this.customerQueryParams.size = this.customerPagination.rowsPerPage;
      this.getCustomerList();
    },
    getCustomerList() {
      this.showCustomerListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.customerTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.showCustomerListLoading = false;
        });
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.name = "";
      this.customerQueryParams.email = "";
      this.customerQueryParams.creditLevelId = "";
      this.customerQueryParams.township = "";

      this.getCustomerList().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    getTax() {
      return taxService
        .getTaxByStatus("ACTIVE")
        .then((res) => {
          if (res.data) {
            this.tax = res.data;
            this.sale.taxId = this.tax.id;
            this.sale.taxName = this.tax.name;
            this.sale.taxType = this.tax.taxType;
            this.sale.taxPercentage = this.tax.percentage;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy ? this.pagination.sortBy + "," + order : ""
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getCategoriesByStatus() {
      return categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
          if (!this.queryParams.categoryId) {
            this.queryParams.categoryId = this.categoryList[0].id;
            this.categoryName = this.categoryList[0].name;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    addToCart(productUnit) {
      if (this.isItemExist(productUnit, this.isFOC)) {
        let isFOCFlag = this.isFOC;
        this.sale.saleItems.forEach(function (item) {
          if (
            item.productUnitId === productUnit.id &&
            item.isFOC === isFOCFlag
          ) {
            if (item.qty < productUnit.qty) item.qty = Math.abs(item.qty) + 1;
          }
        });
      } else {
        let item = {
          productUnitId: 0,
          productId: 0,
          qty: 0,
          unitPrice: 0,
          barcode: "",
          totalPrice: 0,
          factorUnitName: "",
          productName: "",
          productName2: "",
          remark: "",
          discountPercent: 0,
          actualPrice: 0,
          isFOC: false,
        };

        item.productUnitId = productUnit.id;
        item.productId = productUnit.product.id;
        item.barcode = productUnit.barcode;
        item.qty = 1;
        item.unitPrice = productUnit.sellingPrice;
        item.factorUnitName = productUnit.factorUnitName;
        item.productName = productUnit.product.name;
        item.productName2 = productUnit.product.name2;
        item.discountPercent = productUnit.sellingPricePercentage;

        item.remark = "";
        if (this.isFOC) {
          item.isFOC = this.isFOC;
        }
        this.sale.saleItems.push(item);
      }
    },
    toggleDiscount() {
      if (this.isItemDiscount) {
        this.sale.isItemDiscount = true;
      } else {
        this.sale.isItemDiscount = false;
      }
    },
    calculateAmount() {
      let total = 0;
      this.sale.saleItems.forEach((item) => {
        if (!item.isFOC) {
          if (this.isItemDiscount) {
            let discount = (
              item.unitPrice *
              (item.discountPercent / 100)
            ).toFixed(6);
            discount = parseFloat(discount);
            item.totalPrice = item.qty * (item.unitPrice - discount);
          } else {
            item.totalPrice = item.qty * item.unitPrice;
          }
          total += item.totalPrice;
        }
      });
      total = parseFloat(total.toFixed(6));
      this.sale.totalAmount = total;
      let commercialTax = 0;
      if (this.sale.taxPercentage > 0) {
        commercialTax = parseFloat(
          (total * (this.sale.taxPercentage / 100)).toFixed(6)
        );
      }
      if (!this.isTaxOn) {
        commercialTax = 0;
      }
      let taxType = this.sale.taxType;
      if (taxType === "ADD_ON") {
        this.netAmount = total + commercialTax;
      } else {
        this.netAmount = total - commercialTax;
      }
      this.sale.taxAmount = commercialTax;
      if (this.isDiscountPercentage) {
        this.sale.discountAmount = parseFloat(
          (
            this.netAmount *
            (this.sale.discountPercentage / 100)
          ).toFixed(6)
        );
      }
      this.netAmount = this.netAmount - this.sale.discountAmount;
      if (this.isPromotionPercentage) {
        this.sale.promotionAmount = parseFloat(
          (
            this.netAmount *
            (this.sale.promotionPercentage / 100)
          ).toFixed(6)
        );
      }
      this.netAmount = this.netAmount - this.sale.promotionAmount;
      this.netAmount = this.netAmount + parseFloat(this.sale.expenseAmount);
      this.netAmount = parseFloat(this.netAmount.toFixed(6));
      if(this.payType == 'CREDIT'){
        this.receivedAmount = 0;
      } else{
      this.receivedAmount = parseFloat(this.netAmount.toFixed(6));
      }
      if (this.isAdvancedAmount) {
        if (this.totaladvancedAmount < this.netAmount) {
          this.receivedAmount = parseFloat(this.totaladvancedAmount.toFixed(6));
        }
      }
    },
    changeReceiveAmount() {
      if (this.isAdvancedAmount) {
        if (this.receivedAmount > this.totaladvancedAmount) {
          this.receivedAmount = this.totaladvancedAmount;
          this.responseError =
            "Receive Amount must not be greater than Total Advanced Amount";
          this.messageDialogBox = true;
        }
      }
    },
    save() {
      this.sale.payChange = parseFloat(this.payChangeAmount).toFixed(6);
      this.sale.netAmount = parseFloat(this.netAmount).toFixed(6);
      this.sale.payType = this.payType;
      this.sale.receivedAmount = parseFloat(this.receivedAmount).toFixed(6);
      this.sale.isAdvancedAmount = this.isAdvancedAmount;
      if (this.saleRemark) {
        this.sale.remark = this.saleRemark;
      }
      if (this.sale.backDateDataEntry == "ACTIVE") {
        // convert to millisecond
        this.sale.createdDateInMilliSeconds = commonService.convertToMilliseconds(
          this.createdDate + " " + this.createdTime
        );
      }
      saleService
        .saveSale(this.sale)
        .then((res) => {
          this.sale.saleNo = res.data.sale.saleNo;
          this.sale.saleId = res.data.sale.id;
          this.sale.currencyCode = res.data.sale.currencyCode;
        })
        .then(() => {
          if (this.sale.payType == "CASH") {
            this.printInvoice("invoicePrint");
          } else {
            this.isLoading = true;
            this.printInvoiceById(this.sale.saleId);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
            this.messageDialogBox = true;
            this.isSaleProcessing = false;
          }
        })
        .finally(() => {
          this.isItemDiscount = false;
        });
    },
    printInvoiceById(id) {
      saleService
        .printSaleInvoiceById(id)
        .then((res) => {
          var blob = res;
          saleService.showWindowDialog(blob, "SaleInvoice-" + id);
          this.init();
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    printInvoice(divName) {
      var d = new Date();
      var t = d.toLocaleTimeString();
      var mydate = new Date().toString("MMMM yyyy");
      document.getElementById("date").innerHTML = mydate.substr(0, 16) + t;
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();

      // clear previous cart item
      this.init();
    },
    printOrderNote(divName) {
      var d = new Date();
      var t = d.toLocaleTimeString();
      var mydate = new Date().toString("MMMM yyyy");
      document.getElementById("orderNoteDate").innerHTML =
        mydate.substr(0, 16) + t;
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = "";
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },
    init() {
      if (this.sale) {
        this.sale = new Sale();
      }
      let user = JSON.parse(localStorage.getItem("user"));
      this.sale.backDateDataEntry = JSON.parse(
        localStorage.getItem("BACKDATE_DATA_ENTRY")
      );
      this.sale.shopId = user.shop.id;
      this.sale.counterId = user.counterId;
      this.sale.shiftAssignDetailId = user.shiftAssignDetailId;
      this.sale.shopName = user.shop.name;
      this.sale.phoneNo = user.shop.phoneNo;
      this.sale.address = user.shop.address;
      this.sale.username = user.username;
      this.sale.counterName = user.counterName;

      this.isSaleProcessing = false;
      this.saleRemark = "";
      this.getCreditLevels();
      this.getTax();
      this.getAllCustomer();
      this.getCategoriesByStatus()
        .then(this.getProductList)
        .then(() => {
          this.ignorePagingWatch = false;
        });
      this.getBinList(this.sale.shopId);

      // check park items
      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      if (parkItemsLocalStorage) {
        this.parkItems = parkItemsLocalStorage;
      }

      //for deep linking
      if (this.$route.query.status) {
        this.queryParams.status = this.$route.query.status;
      }
      if (this.$route.query.categoryId) {
        this.queryParams.categoryId = this.$route.query.categoryId;
      }
      if (this.$route.query.barcode) {
        this.queryParams.barcode = this.$route.query.barcode;
      }
      if (this.$route.query.page) {
        this.pagination.page = this.$route.query.page;
      }
      if (this.$route.query.size) {
        this.pagination.size = this.$route.query.size;
      }
      if (this.$route.query.categoryId) {
        this.queryParams.categoryId = this.$route.query.categoryId;
      }
      if (this.$route.query.warehouseId) {
        this.queryParams.warehouseId = this.$route.query.warehouseId;
      } else {
        this.queryParams.warehouseId = user.shop.warehouse.id;
      }
      this.queryParams.binIds = user.shop.binIds;
      this.customerQueryParams.status =  "ACTIVE";
    },

    showProductUnitDialog(product) {
      this.openProductUnitDialog = true;
      this.productUnitList = product.productUnits;
      this.productCode = product.code;
      this.productName = product.name;
    },

    removeItem(index) {
      this.$delete(this.sale.saleItems, index);
    },
    parkSale() {
      if (!this.$refs.noteDialog.validate()) {
        return;
      }
      this.showNote = false;

      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      if (!parkItemsLocalStorage) {
        parkItemsLocalStorage = [];
      }
      parkItemsLocalStorage.push(this.sale);
      this.parkItems = parkItemsLocalStorage;
      localStorage.setItem("parkItems", JSON.stringify(parkItemsLocalStorage));
      this.init();
    },
    retrieveSale(index) {
      var parkItemsLocalStorage = JSON.parse(localStorage.getItem("parkItems"));
      this.sale = parkItemsLocalStorage[index];
      this.$delete(parkItemsLocalStorage, index);
      this.parkItems = parkItemsLocalStorage;
      localStorage.setItem("parkItems", JSON.stringify(parkItemsLocalStorage));
      this.showParkSales = false;
    },
    closeModal() {
      this.$refs.noteDialog.resetValidation();
      this.showNote = false;
    },
    showPaymentMethods() {
      if (this.$refs.form.validate()) {
        this.showPaymentMethodDialog = true;
        this.confirmBox = false;
      }
    },
    isItemExist(productUnit, isFOC) {
      for (let item of this.sale.saleItems) {
        if (item.productUnitId === productUnit.id && item.isFOC === isFOC) {
          return true;
        }
      }
    },
    getProductUnitByBarcode(bcode) {
      let params = {
        barcode: bcode,
        isSale: true,
      };
      productService
        .getProductUnitByBarcode(params)
        .then((res) => {
          let productUnit = res.data;
          if (productUnit) {
            if (productUnit.qty > 0) {
              this.addToCart(productUnit);
            }
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
            this.messageDialogBox = true;
          }
        })
        .finally(() => {
          this.scanBarcode = "";
        });
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
            let findAll = {
              id: "",
              name: "----All----",
            };
            this.creditLevelList.splice(
              0,
              0,
              JSON.parse(JSON.stringify(findAll))
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setCustomer(customer) {
      this.sale.customerId = customer.id;
      this.sale.customerName = customer.name;
      this.totaladvancedAmount = customer.advancedAmount;
      this.showCustomerListDialog = false;
    },
    changeDiscountSwitch() {
      this.sale.discountPercentage = 0;
      this.sale.discountAmount = 0;
      this.calculateAmount();
    },

    changePromotionSwitch(){
      this.sale.promotionPercentage=0;
      this.sale.promotionAmount=0;
      this.calculateAmount();
    },

    addNewCustomer() {
      this.customerAddDialog = !this.customerAddDialog;
    },

    closeCustomerDialog(customer) {
      this.customerAddDialog = !this.customerAddDialog;
      if (customer.id) {
        this.setCustomer(customer);
      }
    },

    getBinList(shopId) {
      shopService
        .getShopBinList(shopId)
        .then((res) => {
          this.binList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style scoped>
.stock-name {
  width: 110px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.cart {
  font-size: 12px;
}
</style>
